module.exports = __webpack_public_path__ + "static/media/bi-cycle.8e9cb0e4.svg";